export default __webpack_public_path__ + "static/media/Group 6237.1cfbee30.png";